import { EnumTipoProducto, EnumGrupoProducto } from "../settings/enumConfig";

export const getModelProducto = () => ({
    iIdProducto: 0,
    iIdTipoProducto: EnumTipoProducto.Membresia,
    bComercial: true,
    iIdGrupoProducto: EnumGrupoProducto.MeditocProducts,
});

export const getFormProducto = () => ({
    rdTipoProducto: {
        label: "Tipo de producto:",
        required: true,
        value: "",
        message: "Seleccione el tipo de producto:",
    },
    chkComercial: {
        label: "Es comercial:",
        required: true,
        value: false,
        message: "El producto es comercial:",
    },
    txtIdPlan: {
        label: "Id Plan:",
        required: false,
        value: "",
    },
    chkPremium: {
        label: "Sin Anuncios",
        required: false,
        value: false,
        message: "¿Sin Anuncios?",
    },
    txtNombreProducto: {
        label: "Nombre del producto:",
        required: true,
        value: "",
        error: false,
        message: "El nombre del producto es requerido",
        placeholder: "Ej. Membresía 6 meses",
    },
    txtNombreCorto: {
        label: "Nombre corto del producto:",
        required: true,
        value: "",
        error: false,
        message: "El nombre corto del producto es requerido",
        placeholder: "Ej. 6 meses",
    },
    txtDescripcion: {
        label: "Descripción:",
        required: true,
        value: "",
        error: false,
        message: "La descripción del producto es requerida",
        placeholder: "Ej. Un médico contigo, siempre, en donde sea.",
    },
    slcGrupoProducto: {
        label: "Grupo de productos:",
        required: true,
        value: "",
        error: false,
        message: "Seleccione el grupo de productos",
    },
    txtCosto: {
        label: "Costo del producto (en MXN sin IVA):",
        required: true,
        value: "",
        error: false,
        message: "Ingrese el costo del producto, el monto mínimo es de 4 pesos",
        placeholder: "Ej. 600.00",
    },
    txtMesesVigencia: {
        label: "Frecuencia del período:",
        required: true,
        value: "",
        error: false,
        errorplan: false,
        message: "Ingrese la frecuencia de vigencia que contará el producto",
        messageplan: "La frecuencia no puede estar vacía o superar el año",
        placeholder: "Ej. 6",
    },
    slcIntervalo: {
        label: "Intervalo del período:",
        required: true,
        value: "",
        error: false,
        message: "Seleccione el intervalor del período",
    },
    slcVisible: {
        label: "Visibilidad del producto:",
        required: true,
        value: "",
        error: false,
        message: "Seleccione la opción deseada",
    },
    txtCantidadOrientacion: {
        label: "Número de interacciones con Orientaciones Médicas por período:",
        required: false,
        value: "",
        error: false,
        //message: "Ingrese la cantidad de veces que podran utilizar el producto",
        placeholder: "Ej. 0 indica que son ilimitadas la veces durante el período",
    },
    txtCantidadAsistenciaPsicologica: {
        label: "Número de interacciones con Asistencias Psicólogologicas por período:",
        required: false,
        value: "",
        error: false,
        //message: "Ingrese la cantidad de veces que podran utilizar el producto",
        placeholder: "Ej. 0 indica que son ilimitadas la veces durante el período",
    },
    txtCantidadEspecialistaPsicologo: {
        label: "Número de interacciones con Especialista Psicólogo por período:",
        required: false,
        value: "",
        error: false,
        //message: "Ingrese la cantidad de veces que podran utilizar el producto",
        placeholder: "Ej. 0 indica que son ilimitadas la veces durante el período",
    },
    slcIcono: {
        label: "Ícono:",
        required: true,
        value: "",
        error: false,
        message: "Seleccione el ícono para el producto",
    },
    txtPrefijoFolio: {
        label: "Prefijo para los folios:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese el prefijo para identificar el producto",
        placeholder: "Ej. VS",
    },
});

export const getProductoColumns = () => [
    { title: "ID", field: "iIdProducto" },
    { title: "Nombre", field: "sNombre" },
    { title: "Tipo", field: "sTipoProducto" },
    { title: "Grupo de productos", field: "sGrupoProducto" },
    { title: "Costo", field: "sCosto" },
    { title: "Frecuencia", field: "iFrecuencia" },
    { title: "Intervalo", field: "sIntervaloDisplay" },
    { title: "Comercial", field: "sComercial" },
];
